import {
  Component,
} from '@angular/core';
import { IconsComponent } from '@shared/components/icons/icon.component';
import { bootstrapCheck } from '@ng-icons/bootstrap-icons';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  templateUrl: 'settlement-created-modal-content.component.html',
  imports: [IconsComponent, TranslateModule],
})
export class SettlementCreatedModalContentComponent {

  protected iconCheck = bootstrapCheck
}
